import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 157,
	height: 100,
	viewBox: "0 0 157 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: "\n    .main {\n      fill: #2E8AE6\n    }\n\n    .swoosh {\n      fill: #004D99;\n    }\n\n    .strap {\n      fill: #2E8AE6;\n      stroke: #004D99;\n    }\n\n    .strap-circle {\n      fill: #ffffff;\n    }\n\n    body.chakra-ui-dark .main {\n      fill: #82BCF5;\n    }\n\n    body.chakra-ui-dark .swoosh {\n      fill: #2E8AE6;\n    }\n\n    body.chakra-ui-dark .strap {\n      fill: #2E8AE6;\n      stroke: #004D99;\n    }\n\n    body.chakra-ui-dark .strap-circle {\n      fill: #ffffff;\n    }\n  " }),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10C0 4.47716 4.47715 0 10 0H140C145.523 0 150 4.47715 150 10V90C150 95.5228 145.523 100 140 100H10C4.47715 100 0 95.5228 0 90V10Z",
			className: "main"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.08648 1.28839C2.04985 3.00479 0 6.26302 0 10V90C0 95.5229 4.47715 100 10 100H140C144.354 100 148.058 97.2173 149.431 93.3334H148.333C51.2442 101.1 7.52949 78.2479 5.08648 1.28839Z",
			className: "swoosh"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 120,
			y: 29,
			width: 36,
			height: 42,
			rx: 7,
			className: "strap",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 133,
			cy: 50,
			r: 7,
			className: "strap-circle"
		})
	]
});
export default SvgWalletIcon;
